var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _orm=require('./orm');var _orm2=_interopRequireDefault(_orm);
var _Store=require('./Store');var store=_interopRequireWildcard(_Store);
var _Fixture=require('./Fixture');var fixture=_interopRequireWildcard(_Fixture);
var _Position=require('./Position');var position=_interopRequireWildcard(_Position);
var _SecurityDevice=require('./SecurityDevice');var securityDevice=_interopRequireWildcard(_SecurityDevice);
var _StoreAddress=require('./StoreAddress');var storeAddresses=_interopRequireWildcard(_StoreAddress);
var _Area=require('./Area');var area=_interopRequireWildcard(_Area);
var _Floor=require('./Floor');var floor=_interopRequireWildcard(_Floor);
var _AreaLayoutPosition=require('./AreaLayoutPosition');var areaLayoutPosition=_interopRequireWildcard(_AreaLayoutPosition);
var _FixtureLayoutPosition=require('./FixtureLayoutPosition');var fixtureLayoutPosition=_interopRequireWildcard(_FixtureLayoutPosition);
var _PositionLayoutPosition=require('./PositionLayoutPosition');var positionLayoutPosition=_interopRequireWildcard(_PositionLayoutPosition);
var _LayoutPosition=require('./LayoutPosition');var layoutPosition=_interopRequireWildcard(_LayoutPosition);
var _PositionRule=require('./PositionRule');var positionRule=_interopRequireWildcard(_PositionRule);
var _FixtureRule=require('./FixtureRule');var fixtureRule=_interopRequireWildcard(_FixtureRule);
var _StoreRule=require('./StoreRule');var storeRule=_interopRequireWildcard(_StoreRule);
var _Product=require('./Product');var product=_interopRequireWildcard(_Product);
var _Manufacturer=require('./Manufacturer');var manufacturer=_interopRequireWildcard(_Manufacturer);
var _SecuredProduct=require('./SecuredProduct');var securedProduct=_interopRequireWildcard(_SecuredProduct);
var _Organization=require('./Organization');var organization=_interopRequireWildcard(_Organization);
var _Rule=require('./Rule');var rule=_interopRequireWildcard(_Rule);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

module.exports={
actions:_extends({},
store.actions,
fixture.actions,
position.actions,
securityDevice.actions,
storeAddresses.actions,
area.actions,
floor.actions,
areaLayoutPosition.actions,
fixtureLayoutPosition.actions,
positionLayoutPosition.actions,
layoutPosition.actions,
positionRule.actions,
fixtureRule.actions,
storeRule.actions,
product.actions,
manufacturer.actions,
securedProduct.actions,
organization.actions,
rule.actions),

creators:_extends({},
store.creators,
fixture.creators,
position.creators,
securityDevice.creators,
storeAddresses.creators,
area.creators,
floor.creators,
areaLayoutPosition.creators,
fixtureLayoutPosition.creators,
positionLayoutPosition.creators,
layoutPosition.creators,
positionRule.creators,
fixtureRule.creators,
storeRule.creators,
product.creators,
manufacturer.creators,
securedProduct.creators,
organization.creators,
rule.creators),

orm:_orm2.default};